var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', [_c('el-select', { staticClass: "custom-event-select", attrs: { "placeholder": "请选择", "clearable": "" }, on: { "change": _vm.customEventChangeHandler }, model: { value: _vm.customEvent, callback: function callback($$v) {
        _vm.customEvent = $$v;
      }, expression: "customEvent" } }, _vm._l(_vm.customEventOptions, function (item) {
    return _c('el-option', { key: item.value, attrs: { "label": item.label, "value": item.value } });
  }), 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };